import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import listMixin from '../listMixin';
import { mapState } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['tenantName'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicServiceBuildersList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {},
  data: function data() {
    return {
      lastSearch: '',
      tableOptions: defaultTableOptions,
      disableFetchOnCreatedMixin: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'tenantId',
          align: 'center'
        }, {
          text: this.$i18n_t('Common.tenant'),
          value: 'tenantName',
          align: 'start'
        }, {
          text: 'Service Builder URL',
          value: 'serviceBuilderUrl',
          align: 'start',
          sortable: false
        }, {
          value: 'icon',
          align: 'end',
          sortable: false
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'tenantName';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var offset = (page - 1) * itemsPerPage;
      ApiService.tenantGetServiceBuilders(offset, itemsPerPage, sortItem, doSortDesc).then(function (res) {
        _this.list = res.data;
        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function (error) {
        console.error('Error fetching service builders', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    handleClickConsumer: function handleClickConsumer(item) {
      if (!window.open(item.serviceBuilderUrl, '_blank')) {
        window.location.href = item.serviceBuilderUrl;
      }
    }
  }
};